module.exports = __webpack_public_path__ + "static/media/praca.a0d02ff7.png";